/* eslint-disable jsx-a11y/anchor-is-valid */
import {NotificationModel} from 'app/models/NotificationModels'
import {GetNotificationList, MarkAsRead} from 'app/services/notificationsService'
import {ErrorHandler} from 'app/shared/Alfacom/ErrorHandler/ErrorHandler'
import Iconize from 'app/shared/Alfacom/Icon/Iconize'
import Loading from 'app/shared/Alfacom/Loading/Loading'
import Placeholderize from 'app/shared/Alfacom/Placeholder/Placeholderize'
import {EVENT_EMITTER} from 'app/shared/Common/Constants'
import {GetNotificationColor, GetNotificationTypeIcon, NotificationType} from 'app/shared/Common/Enums'
import clsx from 'clsx'
import moment from 'moment'
import {FC, useEffect, useState} from 'react'
import {Badge} from 'react-bootstrap'
import {useBus} from 'react-bus'
import {useNavigate} from 'react-router-dom'
import {KTSVG, toAbsoluteUrl} from '../../../helpers'

const HeaderNotificationsMenu: FC = () => {
  //#region const Variables
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [isNotifyLoading, setIsNotifyLoading] = useState<boolean>(false)
  const [notificationList, setNotificationList] = useState<NotificationModel[]>([])
  const [showMore, setShowMore] = useState<boolean>()
  const [notifyPage, setNotifyPage] = useState(1)
  const [unreadNotificationCount, setUnreadNotificationCount] = useState<number>(0)
  const [refreshInterval, setRefreshInterval] = useState<number>(0)

  const navigate = useNavigate()
  const Bus = useBus()

  const handleShowMore = () => {
    setIsLoading(true)
    GetNotificationList(notifyPage + 1)
      .then((response) => {
        setNotificationList(notificationList.concat(response.NotificationList))
        setShowMore(response.ShowMore)
        setUnreadNotificationCount(response.UnreadNotificationCount)
        Bus.emit(EVENT_EMITTER.NOTIFICATION.UNREAD_NOTIFICATION.UNREAD_NOTIFICATION_COUNT, response.UnreadNotificationCount)
      })
      .catch((error) => {
        ErrorHandler(error)
      })
      .finally(() => {
        setIsLoading(false)
        setNotifyPage(notifyPage + 1)
      })
  }

  const handleNotificationOnClick = (item: NotificationModel) => {
    if (item.MarkRead == true) {
      navigate(item.ActionPath)
    } else if (item.MarkRead == false) {
      navigate(item.ActionPath)

      setIsNotifyLoading(true)
      MarkAsRead(item.Id)
        .then((response) => {
          setNotificationList(
            notificationList.map((notification) => {
              if (notification.Id == item.Id) {
                notification.MarkRead = true
              }
              return notification
            })
          )
          var latestUnreadCount = unreadNotificationCount - 1
          setUnreadNotificationCount(latestUnreadCount)
          Bus.emit(EVENT_EMITTER.NOTIFICATION.UNREAD_NOTIFICATION.UNREAD_NOTIFICATION_COUNT, latestUnreadCount)
        })
        .catch((error) => {
          ErrorHandler(error)
        })
        .finally(() => {
          setIsNotifyLoading(false)
        })
    }
  }
  //#endregion

  //#region useEffect()
  useEffect(() => {
    init()
  }, [])

  useEffect(() => {
    if (refreshInterval > 0) {
      const interval = setInterval(() => {
        _GetNotificationList()
      }, refreshInterval)
      return () => clearInterval(interval)
    }
  }, [refreshInterval])
  //#endregion

  //#region Asynchoronous function
  async function init() {
    await _GetNotificationList()
  }

  async function _GetNotificationList() {
    setIsNotifyLoading(true)
    GetNotificationList(notifyPage)
      .then((response) => {
        setNotificationList(response.NotificationList)
        setShowMore(response.ShowMore)
        setUnreadNotificationCount(response.UnreadNotificationCount)
        setRefreshInterval(response.RefreshInterval)
        Bus.emit(EVENT_EMITTER.NOTIFICATION.UNREAD_NOTIFICATION.UNREAD_NOTIFICATION_COUNT, response.UnreadNotificationCount)
      })
      .catch((error) => {
        ErrorHandler(error)
      })
      .finally(() => {
        setIsNotifyLoading(false)
      })
  }
  //#endregion

  return (
    <>
      <div className='menu menu-sub menu-sub-dropdown menu-column w-350px w-lg-375px' data-kt-menu='true'>
        <div
          className='d-flex flex-column bgi-no-repeat rounded-top h-120'
          style={{backgroundImage: `url('${toAbsoluteUrl('/media/misc/pattern-1.jpg')}')`}}
        >
          <h3 className='d-flex text-white fw-bold px-9 mt-10 mb-6'>
            Notifications
            {/* {(unreadNotification < 1) && (<Badge className='ms-2 bg-danger'>{(notificationList)?notificationList.filter(item=>item.MarkRead == false).length:''}</Badge>)} */}
            {unreadNotificationCount >= 1 && <Badge className='ms-2 bg-danger'>{unreadNotificationCount}</Badge>}
          </h3>
        </div>

        <div className='tab-content'>
          <div className='tab-pane fade show active d-flex flex-column h-400px' id='notification-menu' role='tabpanel'>
            <div
              className={clsx('scroll-y p-5', {
                'h-350px': showMore,
                'h-400px': !showMore,
              })}
            >
              <Loading show={isNotifyLoading} type='spinner'></Loading>

              {notificationList?.length == 0 && (
                <Placeholderize type='secondary' biIcon='bi-bell' title='No Notifications' subtitle='' description={''} />
              )}

              {notificationList?.map((item, index) => (
                <div
                  key={`${item.Id}`}
                  className='d-flex py-4 pt-1 pb-1 gap-4'
                  role='button'
                  onClick={() => {
                    handleNotificationOnClick(item)
                  }}
                >
                  <div className='symbol symbol-35px d-flex align-items-center'>
                    <span className={'symbol-label ' + `bg-light-${GetNotificationColor(item.IconColor)}`}>
                      {/* <Iconize faIcon={`fs-2 ${item.CustomIcon}`} color={GetNotificationColor(item.IconColor)} position='icon-only' /> */}
                      <div className='symbol symbol-35px symbol-fixed position-relative'>
                        {item.Type == NotificationType.ProgramSubmitted ? (
                          <img
                            style={{
                              backgroundImage: `url(${GetNotificationTypeIcon(item.Type)})`,
                              backgroundSize: '80%',
                              backgroundRepeat: 'no-repeat',
                              backgroundPosition: 'center',
                            }}
                          />
                        ) : (
                          <div
                            className={`image-input-wrapper symbol symbol-35px  text-inverse-primary align-items-center fw-bolder d-flex flex-column justify-content-center`}
                            style={{fontSize: '2rem'}}
                          >
                            <Iconize
                              faIcon={`fs-2 ${GetNotificationTypeIcon(item.Type)}`}
                              color={GetNotificationColor(item.IconColor)}
                              position='icon-only'
                            />
                          </div>
                        )}
                      </div>
                    </span>
                  </div>

                  <div className='align-items-center text-truncate'>
                    <div className='mb-1 me-2'>
                      <div className='d-flex align-items-center gap-2'>
                        {!item.MarkRead && <Iconize faIcon='fs-9 fas fa-circle' color='danger' position='icon-only' />}
                        <a
                          href='#'
                          className='fs-6 text-gray-800 text-hover-primary fw-bold text-truncate'
                          onClick={(e) => {
                            e.preventDefault()
                            handleNotificationOnClick(item)
                          }}
                          title={item.Title}
                        >
                          {item.Title}
                        </a>
                      </div>

                      <div dangerouslySetInnerHTML={{__html: item.Message ?? ''}} className='text-gray-600 fs-7 text-wrap'></div>

                      <div className='text-gray-400'>
                        <span className='text-gray-400 fs-8'>
                          {(item.NotifyDateTime != undefined || item.NotifyDateTime != '') && moment(item.NotifyDateTime).startOf('minute').fromNow()}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              ))}

              {!showMore && notificationList.length != 0 && (
                <div className='d-flex flex-column text-center text-gray-400 fs-7 gap-6 pt-6'>
                  <div className='separator separator-content w-100'>
                    <Iconize faIcon='fs-1 fas fa-check-circle' color='primary' />
                  </div>
                  <span>You have seen all the notifications.</span>
                </div>
              )}
            </div>

            {showMore && (
              <div className='text-center border-top d-flex align-items-center flex-grow-1'>
                <span className='btn btn-color-gray-600 btn-active-color-primary w-100' onClick={() => handleShowMore()}>
                  Load More <KTSVG path='/media/icons/duotune/arrows/arr064.svg' className='svg-icon-5' />
                </span>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  )
}

export {HeaderNotificationsMenu}
